export default __webpack_public_path__ + "static/media/headset-icon.a7cb3ff8.png";